<template>
    <div class="btn-group">
        <button
          type="button"
          :class="['btn btn-default dropdown-toggle flex-row align-items-center justify-content-between', compact ? 'compact' : '']"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ title }}
          <i class="mdi mdi-chevron-down"></i>
        </button>
        <ul
          v-if="isOptionsArray"
          class="dropdown-menu pull-right"
        >
          <li
            v-for="(option, index) in options"
            :key="index"
            class="less-padding"
          >
            <a
              class="tooltip-toggle"
              @click="handleClick(option)"
            >
              {{ option.title }}
            </a>
          </li>
        </ul>
        <ul
          v-else
          class="dropdown-menu pull-right"
        >
          <li
            v-for="(categoryOptions, categoryName) in options"
            :key="categoryName"
          >
            <p class="category-name">{{categoryName}}</p>
            <ul class="options-menu">
              <li
                v-for="(option, index) in categoryOptions"
                :key="categoryName + index"
              >
                <a
                  class="tooltip-toggle"
                  @click="handleClick(option)"
                >
                  {{ option.title }}
                </a>
              </li>
            </ul>
          </li>
        </ul>
    </div>
</template>

<script>

export default {
  name: "DropdownButtonList.vue",
  props: {
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    title:{
      type: String,
      required: false,
      default: ''
    },
    options:{
      type: [Array, Object], //sub menu's
      required: false,
      default: []
    },
    compact:{
      type: Boolean,
      required: false
    }
  },
  methods:{
    handleClick(option){
      if ( option.click ) option.click();
    }
  },
  computed:{
    isOptionsArray(){
      return Array.isArray(this.options);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';
.dropdown-menu{
  padding-bottom: 0;
  margin-bottom: $spacing-md;
  scrollbar-width: thin;
}
li {
  list-style-type: none !important;
  padding-bottom: 8px;
  padding-top: 8px;
  &.less-padding{
    padding-bottom: 1px !important;
    padding-top: 1px !important;
  }
}
.options-menu{
  padding-left: $spacing-sm;
  &:not(:last-child){
    margin-bottom: $spacing-xxs;
  }
  margin-bottom: $spacing-xs;
  li{
    padding-top: $spacing-xs !important;
    padding-bottom: $spacing-xs !important;
    &:hover{
      background-color: #f5f5f5;
    }
    a {
      list-style-type: none !important;
      color: $color-black !important;
      white-space: nowrap;
    }
  }
}
.category-name {
  color: $color-primary !important;
  margin: 0;
  margin-left: $spacing-sm;
  font-size: 15px !important;
}
.dropdown-toggle{
  height: $spacing-xxl;
  min-height: $spacing-xl;
}
.compact{
  height: $spacing-xl;
  min-height: $spacing-xl;
  padding: 0px 6px 0px 6px;
  border-radius: 4px;
}
</style>
